import { useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import HomeImage from '../../assets/images/HomeImage.svg';

import './Hero.css';

export default function Main() {
    const [displayText, setDisplayText] = useState("Informatică");

    const handleHover = () => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const targetText = "Informatică";
        let iteration = 0;

        const interval = setInterval(() => {
            setDisplayText(
                targetText
                    .split("")
                    .map((letter, index) => {
                        if (index < iteration) return targetText[index];
                        return letters[Math.floor(Math.random() * letters.length)];
                    })
                    .join("")
            );

            if (iteration >= targetText.length) {
                clearInterval(interval);
                setDisplayText(targetText);
            }

            iteration += 1 / 2;
        }, 60);
    };

    return (
        <Container className="heroContainer worldwide">
            <Row>
                <Col xl={5}>
                    <p className="heroTitle1">
                        Învață{" "}
                        <span>
                            <span style={{ color: "white" }}>{"<"}</span>
                            <span className="glitchText" onMouseEnter={handleHover}>
                                {displayText}
                            </span>
                            <span style={{ color: "white" }}>{"/>"}</span>
                        </span>
                        {" "}și creează-ți propriul cod! Ce mai aștepți?
                    </p>
                    <p className="heroTitle2">
                        Informatica poate părea complicată, dar nu trebuie să fie așa, căci această disciplină nu
                        este despre noroc, ci despre învățare inteligentă. Cu puțin efort și ghidarea potrivită,
                        poți ajunge rapid la rezultatele dorite. Hai să lucrăm împreună și să îți construim un plan
                        de pregătire individualizat. Pregătit?
                    </p>
                    <div className="heroButtonContainer">
                        <a href="/contact">
                            <Button className="heroButton">Contactează-mă</Button>
                        </a>
                    </div>
                </Col>
                <Col xl={7} className="homeImageContainer d-flex justify-content-center align-items-center">
                    <img src={HomeImage} className="homeImage" alt="HomeImage"/>
                </Col>
            </Row>
            <Row>
                <div className="heroPromoContainer">
                    <span className="heroPromoText">Discipline:</span>
                    <div className="heroLogoContainer">
                        <div className="logos">
                            <div className="logoItems">
                                Matematică | Informatică | Tehnologia Informației și a Comunicațiilor | Programare |
                                Matematică | Informatică | Tehnologia Informației și a Comunicațiilor | Programare |
                            </div>
                        </div>
                    </div>
                </div>
            </Row>
        </Container>
    );
}